module.exports = __webpack_public_path__ + "img/cszl-4.9e15a14e.png";